<template>
    <div>
		<div class="d-flex justify-space-between align-center">
			<v-tabs
				v-model="tabs"
				center-active
				active-class="mid-primary"
				color="white"
            >
                <v-tab :to="{ name: 'add-vacation-type' }">
                    <v-icon class="me-1"> mdi-calendar-edit </v-icon>
                    {{ $T('Settings.tabs.vacationType') }}
                </v-tab>

                <v-tab :to="{ name: 'add-penalties-and-rewards-type' }">
					<v-icon
						class="me-1">
						mdi-scale-balance
					</v-icon>
					{{ $T('Settings.tabs.penaltiesAndRewardsType') }}
				</v-tab>

                <v-tab :to="{ name: 'add-permissions-type' }">
					<v-icon
						class="me-1">
						mdi-scale-balance
					</v-icon>
					{{ $T('Settings.tabs.PermissionsTypes') }}
				</v-tab>

                <v-tab :to="{ name: 'add-missions-type' }">
					<v-icon
						class="me-1">
						mdi-scale-balance
					</v-icon>
					{{ $T('Settings.tabs.MissionsTypes') }}
				</v-tab>
            </v-tabs>

        </div>
        
		<v-divider></v-divider>

        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: 0
        }
    }
}
</script>
